const DISASTER_NAMES = {
  FLOOD: 'Banjir',
  FIRE: 'Kebakaran'
}

export function getName (type) {
  return DISASTER_NAMES[type]
}